import { RadioGroup, RadioGroupItem } from "../../ui/radio-group";

export function RadioField({
  item,
  value,
  error,
  helperText,
  disabled,
  onValueChange,
  className, // for radio input styling (height/size)
  labelClassName, // for label text styling
}) {
  const orientation = item?.orientation || "horizontal";


  return (
    <RadioGroup
      value={value}
      onValueChange={(newValue) => onValueChange?.(newValue)}
      disabled={disabled}
      className={`
        ${
          orientation === "vertical"
            ? "space-y-2"
            : "flex flex-wrap gap-x-4 gap-y-2"
        }
      `}
    >
      {item.options?.map((option) => {
        const isOptionDisabled = disabled || option.disabled; // Check both global and per-option disabled
        
        return (
          <div key={option.value} className="flex items-center space-x-2">
            <RadioGroupItem
              id={`${item.pathToValue}-${option.value}`}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => {
                let val = e.target.value;
                if (val === "true") val = true;
                if (val === "false") val = false;
                onValueChange(val);
              }}
              disabled={isOptionDisabled}
              className={`
                ${error ? "border-red-500 hover:border-red-500 focus:border-red-500" : ""}
                ${className || ""}
              `}
            />
            <label
              htmlFor={`${item.pathToValue}-${option.value}`}
              className={`
                text-sm font-medium select-none
                ${isOptionDisabled ? "cursor-not-allowed opacity-70 text-gray-400" : "cursor-pointer text-gray-700"}
                ${labelClassName || ""}
              `}
            >
              {option.label}
            </label>
          </div>
        );
      })}
    </RadioGroup>
  );
}